<p class="header">
  <mat-icon class="error-icon">error</mat-icon> <span class="error-title">{{ 'fatalError.title' | translate }}</span>
</p>

<h4>{{ 'fatalError.codeTitle' | translate }}</h4>
<input type="text" [value]="_encodedData" class="encoded-error" (click)="onEncodedClick()" readonly #encoded>

<h4>{{ 'fatalError.informationTitle' | translate }}</h4>
<div class="json-container">
  <pre>{{ _jsonData }}</pre>
</div>
